import { useEffect, useState } from 'react';
import { WorkspaceMemberRoles } from './vo/WorkspaceMemberRoles';
import type { WorkspaceId } from 'balus-common';
import { ObjectRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';

export const useWorkspaceMemberRoles = (workspaceId: WorkspaceId): WorkspaceMemberRoles | null => {
  const [result, setResult] = useState<WorkspaceMemberRoles | null>(null);

  useEffect(() => {
    const repo = new ObjectRepository(WorkspaceMemberRoles, RTDBPath.Workspace.memberRolesPath(workspaceId));

    repo.addListener((memberRoles) => setResult(memberRoles));

    return () => {
      repo.removeListener();
    };
  }, [workspaceId]);

  return result;
};
